import { Handle, Position } from '@xyflow/react'
import { isFired } from './useFiredFlash'

/**
 * Set Variable action node — sets an animation variable at runtime.
 * Wired into event chains via exec handles.
 *
 * data.varName  — variable name to set
 * data.varValue — static value (overridden by data-pin wire if connected)
 */

const HEADER_BG     = '#0a2830'
const HEADER_ACTIVE = '#105040'
const ACCENT        = '#40b8d0'
const BORDER_SEL    = '#40b8d0'
const BORDER_IDLE   = '#0d3040'

export function SetVariableNode({ data, selected }) {
  const fired = isFired(data)
  const stop  = e => e.stopPropagation()

  return (
    <div style={{
      background: selected ? '#081a1e' : '#050e12',
      border: `2px solid ${fired ? '#ffcc44' : selected ? BORDER_SEL : BORDER_IDLE}`,
      borderRadius: 6,
      minWidth: 210,
      fontFamily: 'var(--m-font)',
      boxShadow: fired ? '0 0 14px rgba(255,200,40,0.6)' : selected ? '0 0 12px rgba(40,180,200,0.15)' : 'none',
    }}>
      {/* Header */}
      <div style={{
        background: selected ? HEADER_ACTIVE : HEADER_BG,
        padding: '6px 12px',
        display: 'flex', alignItems: 'center', gap: 8, position: 'relative',
      }}>
        <Handle type="target" position={Position.Left} id="execIn"
          style={{ background: '#ddd', width: 12, height: 12, borderRadius: 2, border: '2px solid #aaa' }} />
        <span style={{ fontSize: 13 }}>📝</span>
        <span style={{ color: ACCENT, fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>Set Variable</span>
        <Handle type="source" position={Position.Right} id="execOut"
          style={{ background: '#ddd', width: 12, height: 12, borderRadius: 2, border: '2px solid #aaa' }} />
      </div>

      {/* Variable name */}
      <div style={{ padding: '8px 12px 4px' }}>
        <div style={{ color: '#1a3840', fontSize: 9, marginBottom: 3, letterSpacing: 0.5 }}>VARIABLE</div>
        <input
          value={data.varName ?? ''}
          onChange={e => data.onChange?.('varName', e.target.value)}
          onMouseDown={stop}
          placeholder="ConversationalState"
          style={{
            width: '100%', boxSizing: 'border-box',
            background: '#020a0e', border: '1px solid #0d2830',
            color: ACCENT, padding: '4px 7px',
            borderRadius: 3, fontSize: 10,
            fontFamily: 'var(--m-mono)', outline: 'none',
          }}
        />
      </div>

      {/* Value — with optional data-pin wire */}
      <div style={{ padding: '4px 12px 8px', position: 'relative' }}>
        <div style={{ color: '#1a3840', fontSize: 9, marginBottom: 3, letterSpacing: 0.5 }}>VALUE</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Handle
            type="target"
            position={Position.Left}
            id="in-value"
            style={{ background: '#c060e8', width: 10, height: 10, borderRadius: '50%', border: '2px solid #80309866' }}
          />
          <input
            value={data.varValue ?? ''}
            onChange={e => data.onChange?.('varValue', e.target.value)}
            onMouseDown={stop}
            placeholder="idle"
            style={{
              width: '100%', boxSizing: 'border-box',
              background: '#020a0e', border: '1px solid #0d2830',
              color: '#60d0b0', padding: '4px 7px',
              borderRadius: 3, fontSize: 10,
              fontFamily: 'var(--m-mono)', outline: 'none',
            }}
          />
        </div>
      </div>
    </div>
  )
}
